export default __webpack_public_path__ + "static/media/mobile.88b152be.png";